interface formatNumberProps {
  currency?: string;
  locale?: string;
  number: number;
  style?: keyof Intl.NumberFormatOptionsStyleRegistry;
}

function formatNumber({
  currency = 'USD',
  locale = 'en-US',
  number,
  style = 'currency',
  ...rest
}: formatNumberProps) {
  const maximumFractionDigits = Number.isInteger(number) ? 0 : 2;

  return new Intl.NumberFormat(locale, { style, currency, maximumFractionDigits, ...rest }).format(
    number
  );
}

export default formatNumber;
